import PropTypes from "prop-types";
import React from "react";

// Inline loading spinner for buttons and action feedback.
// Renders just the <i> so it drops in wherever a plain FA icon was
// (className carries margins/sizes like ms-1, me-2, fa-lg onto the icon).
// Pass `text` to append a label after the spinner.
export const InlineSpinner = ({
  text = "",
  icon = "fa-solid fa-spinner fa-spin",
  className = "",
}) => {
  const spinner = <i className={`${icon} ${className}`.trim()} />;
  return text ? (
    <span>
      {spinner}
      <span className="ms-1">{text}</span>
    </span>
  ) : (
    spinner
  );
};

InlineSpinner.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
};
